function defaultValue() {
  return {
    search: {
      from: null,
      to: null
    },
    listing: {
      date: null,
      hour: null,
    }
  }
}

export function read() {
  return JSON.parse(localStorage.getItem('chosenDate'));
}

export function readListing() {
  return read().listing;
}

export function readSearch() {
  try {
    const searchData = JSON.parse(localStorage.getItem('chosenSearchDate'));
    return searchData ? searchData : { from: null, to: null };
  } catch (error) {
    return { from: null, to: null };
  }
}

export function writeSearchDate(from, to) {
  const data = { from, to };
  return localStorage.setItem('chosenSearchDate', JSON.stringify(data));
}

export function writeListingDate(date, hour = null) {
  let data = defaultValue();
  data.listing.date = date;
  if (hour !== null) {
    data.listing.hour = hour;
  }
  return localStorage.setItem('chosenDate', JSON.stringify(data));
}

export function clear() {
  localStorage.removeItem('chosenDate');
}

export function clearSearchDate() {
  localStorage.removeItem('chosenSearchDate');
}

export function readAndValidateSearchDates() {
  try {
    const searchData = JSON.parse(localStorage.getItem('chosenSearchDate'));
    if (!searchData || !searchData.from || !searchData.to) {
      return { from: null, to: null };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const endDate = new Date(searchData.to);
    endDate.setHours(0, 0, 0, 0);

    if (endDate < today) {
      clearSearchDate();
      return { from: null, to: null };
    }

    return searchData;
  } catch (error) {
    // console.warn('Error validating stored search dates:', error);
    return { from: null, to: null };
  }
}

export default {
  read,
  readListing,
  readSearch,
  readAndValidateSearchDates,
  writeSearchDate,
  writeListingDate,
  clear,
  clearSearchDate
};
